const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': '#070b14',
    'ui-secondary': '#0d1320',
    'ui-tertiary': '#151e2e',

    'ui-modal-overlay': '#02040aaa',
    'ui-modal-background': '#0a0f1a',
    'ui-modal-foreground': '#e8edf7',
    'ui-modal-header-background': '#111a2a',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#0a0f1a',

    'ui-black-transparent': '#ffffff26',

    'text-primary': '#e8edf7',

    'menu-bar-background': '#0b111d',

    'assets-background': '#080d17',

    'input-background': '#111a29',

    'popover-background': '#101827',

    'badge-background': '#101d31',
    'badge-border': '#1d3555',

    'fullscreen-background': '#060a12',
    'fullscreen-accent': '#0b1321',

    'page-background': '#070b14',
    'page-foreground': '#e8edf7',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': '#ffffff30',

    'link-color': '#5bb8ff',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.7)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.7)'
};

const blockColors = {
    insertionMarker: '#b9c7dc',

    workspace: '#0d1421',

    toolboxSelected: '#162236',
    toolboxText: '#c7d2e3',
    toolbox: '#080d17',

    flyout: '#0a101b',

    scrollbar: '#3c4b62',

    valueReportBackground: '#111b2b',
    valueReportBorder: '#263750',
    valueReportForeground: '#e8edf7',

    contextMenuBackground: '#0a101b',
    contextMenuBorder: '#ffffff1f',
    contextMenuForeground: '#e8edf7',
    contextMenuActiveBackground: '#172338',
    contextMenuDisabledForeground: '#59677d',

    flyoutLabelColor: '#b9c7dc',

    checkboxInactiveBackground: '#111927',
    checkboxInactiveBorder: '#8998ad',

    buttonBorder: '#8191a8',
    buttonActiveBackground: '#182337',
    buttonForeground: '#c7d2e3',

    zoomIconFilter: 'invert(100%)',

    gridColor: 'transparent'
};

export {
    guiColors,
    blockColors
};
